<template>
 <Home/>
</template>

<script>

import Home from "@/views/Home.vue";
import BigWin from "@/components/BigWin.vue";

export default {
  name: 'App',
  components: {BigWin, Home}
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
